import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Spacer,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Tooltip,
  Tr,
  useToast,
} from '@chakra-ui/react';
import axios from 'axios';
import { useEffect, useState } from 'react';

interface FailedInventoryModal {
  isOpen: boolean;
  onClose: () => void;
  selectedItem: any;
  setUpdatePage: any;
}

interface CurrentItem {
  worklistInventoryId: string;
  workQueueInventoryStatus: string;
  transactionState: string;
  ComponentName: string;
  Remarks: string;
  TransactionStatus: string;
  WorkQueueInventoryStatus: string;
  accountno: string;
  appealId: number;
  healthplanname: string;
  plantype: string;
  regioncode: string;
  worklistinventoryid: number;
  CodeType: string;
  DeliveryOption: string;
  ServiceType: string;
}

function FailedInventoryModal({
  isOpen,
  onClose,
  selectedItem,
  setUpdatePage,
}: FailedInventoryModal) {
  const toast = useToast();

  const [currentItem, setCurrentItem] = useState<CurrentItem>(selectedItem);
  const [componentName, setComponentName] = useState(selectedItem.ComponentName);
  const [status, setStatus] = useState(selectedItem.WorkQueueInventoryStatus);
  //const [remark, setRemark] = useState(selectedItem.Remarks);
  //const [filteredRemarks, setFilteredRemarks] = useState([]);

  const UpdateFailedInventory = async () => {
    try {
      const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;
      const tokenUrl = process.env.REACT_APP_TOKEN_URL_SIS as string;

      const tokenResponse = await axios.get(tokenUrl);
      if (tokenResponse.data.success) {
        const data = {
          worklistInventoryId: currentItem.worklistinventoryid,
          workQueueInventoryStatus: currentItem.WorkQueueInventoryStatus,
          transactionState: currentItem.ComponentName,
          remarks: currentItem.Remarks,
        };

        const validationResponse = await axios.post(
          baseurl + '/Validation/Accounts',
          data,
          {
            headers: {
              Pragma: 'no-cache',
              Authorization: `Bearer ${tokenResponse.data.token}`,
            },
          }
        );

        if (validationResponse.data.success) {
          toast({
            title: 'Success ',
            position: 'top',
            description: 'Inventory Item has been successfully Updated!',
            status: 'success',
            duration: 9000,
            isClosable: true,
          });
          setUpdatePage(true);
        } else {
          throw new Error('Failed to update validation data');
        }
      } else {
        throw new Error('Failed to retrieve auth token');
      }
    } catch (error) {
      console.error('Error updating validation data:', error);
    }
  };

  // const RemarksFilter = async () => {
  //   try {
  //     const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;
  //     const tokenUrl = process.env.REACT_APP_TOKEN_URL_SIS as string;
  //     const tokenResponse = await axios.get(tokenUrl);

  //     if (tokenResponse.data.success) {
  //       const validationResponse = await axios.get(
  //         baseurl + '/CompletionNotes/get_completion_notes',
  //         {
  //           headers: {
  //             Pragma: 'no-cache',
  //             Authorization: 'Bearer ' + tokenResponse.data.token,
  //           },
  //         }
  //       );

  //       if (validationResponse.data.success) {
  //         const data = validationResponse.data.result;
  //         // Filtering logic based on componentName and status
  //         const filteredData = data.filter((item: any) => {
  //           return (
  //             item.componentName === componentName && item.statusType === status
  //           );
  //         });
  //         setFilteredRemarks(filteredData);
  //       } else {
  //         throw new Error('Failed to fetch validation data');
  //       }
  //     } else {
  //       throw new Error('Failed to retrieve auth token');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching validation data:', error);
  //   }
  // };

  useEffect(() => {
    setCurrentItem(selectedItem);
  }, [selectedItem]);

  // useEffect(() => {
  //   RemarksFilter();
  // }, [componentName, status, selectedItem]);

  return (
    <>
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={() => {
          onClose();
        }}
        size="2xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center">Update Failed Inventory </ModalHeader>
          <ModalCloseButton
            color="white"
            bg="#002677"
            onClick={() => {
              onClose();
            }}
          />
          <ModalBody>
            <Table fontSize="15px" size="sm">
              <Tbody>
                <Tr>
                  <Td fontWeight="bold">Region:</Td>
                  <Td>{currentItem.regioncode}</Td>
                  <Td fontWeight="bold">Account No:</Td>
                  <Td>{currentItem.accountno}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight="bold">Health Plan Name:</Td>
                  <Td>
                    {currentItem.healthplanname ? (
                      <Tooltip
                        bg="#002677"
                        color="white"
                        label={currentItem.healthplanname}
                        aria-label="healh-plan-name"
                        placement="left-start"
                        hasArrow
                        arrowSize={10}
                      >
                        {currentItem.healthplanname.length > 25
                          ? `${currentItem.healthplanname.slice(0, 25)} ...`
                          : currentItem.healthplanname}
                      </Tooltip>
                    ) : (
                      ''
                    )}
                  </Td>
                  <Td fontWeight="bold">Plan Type:</Td>
                  <Td>{currentItem.plantype}</Td>
                </Tr>

                <Tr>
                  <Td fontWeight="bold">Code Type:</Td>
                  <Td>{currentItem.CodeType}</Td>
                  <Td fontWeight="bold">Service Type:</Td>
                  <Td>{currentItem.ServiceType}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight="bold"> Delivery Option:</Td>
                  <Td>{currentItem.DeliveryOption}</Td>

                  <Td fontWeight="bold">Inventory ID:</Td>
                  <Td>{currentItem.worklistinventoryid}</Td>
                </Tr>
                {/* <Tr>
                  <Td fontWeight="bold">Remark:</Td>
                  <Td colSpan={3}>{currentItem.Remarks}</Td>
                </Tr> */}
                <Tr>
                  <Td fontWeight="bold">Status:</Td>
                  <Td>
                    <Select
                      isRequired
                      value={currentItem.WorkQueueInventoryStatus}
                      onChange={e => {
                        const newValue = e.target.value;
                        setCurrentItem(prevState => ({
                          ...prevState,
                          WorkQueueInventoryStatus: newValue,
                        }));
                        setStatus(e.target.value);
                      }}
                      size="xs"
                      border="1px solid #d3d3d3"
                    >
                      <option value="SE">SE</option>
                      <option value="BE">BE</option>
                      <option value="CS">CS</option>
                    </Select>
                  </Td>

                  <Td fontWeight="bold">Component Name:</Td>
                  <Td>
                    <Select
                      isRequired
                      value={currentItem.ComponentName}
                      onChange={e => {
                        const newValue = e.target.value;
                        setCurrentItem(prevState => ({
                          ...prevState,
                          ComponentName: newValue,
                        }));
                        setComponentName(e.target.value);
                      }}
                      size="xs"
                      border="1px solid #d3d3d3"
                    >
                      <option value="Auto Job Runner">Auto Job Runner</option>
                      <option value="PFSChecker">PFSChecker</option>
                      <option value="PFSSender">PFSSender</option>
                      <option value="Validate">Validate</option>
                      <option value="AvailityUpload">AvailityUpload</option>
                      <option value="Sender">Sender</option>
                      <option value="Completion">Completion</option>
                      <option value="Extractor">Extractor</option>
                      <option value="Downloader">Downloader</option>
                      <option value="Loader">Loader</option>
                      <option value="ReadyForFaxChecker">
                        ReadyForFaxChecker
                      </option>
                    </Select>
                  </Td>
                </Tr>
              </Tbody>
            </Table>
            <FormControl ml={4} mt={3}>
              <HStack>
              <FormLabel fontWeight="bold">Remark:</FormLabel>
              <Textarea
                placeholder="Write Some notes"
                value={currentItem.Remarks}
                onChange={e => {
                  const newValue = e.target.value;
                  setCurrentItem(prevState => ({
                    ...prevState,
                    Remarks: newValue,
                  }));
                }}
              />
              </HStack>
            </FormControl>
          </ModalBody>
          <ModalFooter justifyContent="center">
            <Button
              onClick={() => {
                onClose();
              }}
              bg="#002677"
              color="white"
              h="30px"
              w="fit-content"
              mr="5px"
            >
              Cancel
            </Button>
            <Spacer />
            <Button
              bg="#002677"
              color="white"
              h="30px"
              w="fit-content"
              onClick={() => {
                UpdateFailedInventory();
                onClose();
              }}
            >
              Update
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default FailedInventoryModal;
